import { PublicKey } from '@solana/web3.js';

// Your deployed program ID on devnet
export const PREDICTION_MARKET_PROGRAM_ID = new PublicKey('2Jso3cMEDPjQYx1nKsWPsCkJzzAj8kpVsTwq4PSRPGV1');

// Your custom token mint
export const MARKET_TOKEN_MINT = new PublicKey('2Jso3cMEDPjQYx1nKsWPsCkJzzAj8kpVsTwq4PSRPGV1');

// Network configuration
export const SOLANA_NETWORK = 'devnet';
export const SOLANA_RPC_URL = 'https://api.devnet.solana.com';

// Backend API configuration
// Use relative URLs - works in both dev (Vite proxy) and production (Express serves everything)
export const API_BASE_URL = (import.meta as any).env?.VITE_API_URL?.replace('/api', '') || '';

// Program configuration
export const PROGRAM_CONFIG = {
  programId: PREDICTION_MARKET_PROGRAM_ID,
  tokenMint: MARKET_TOKEN_MINT,
  network: SOLANA_NETWORK,
  rpcUrl: SOLANA_RPC_URL,
  apiBaseUrl: API_BASE_URL,
};